import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

export const Route = createFileRoute('/shared-chat/$id')({
  validateSearch: z.object({
    publicToken: z.string(),
  }),
});
